($ => {

    "use strict";
    console.log("SJM app.js loaded");

})(jQuery);